import { render, staticRenderFns } from "./PatientsRequestsTable.vue?vue&type=template&id=5e5c9848&scoped=true&"
import script from "./PatientsRequestsTable.vue?vue&type=script&lang=js&"
export * from "./PatientsRequestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c9848",
  null
  
)

export default component.exports